import {
  type CustomAppDiagnostic,
  CustomAppDiagnosticSchema,
} from '@streamlain/view-config';

export type MarketplaceActionError = Error & {
  code?: string;
  details?: unknown;
  diagnostics?: CustomAppDiagnostic[];
};

export function normalizeMarketplaceErrorPayload(body: any): any {
  return body?.message &&
    typeof body.message === 'object' &&
    !Array.isArray(body.message)
    ? body.message
    : body;
}

export function createMarketplaceActionError(
  body: any,
  fallbackMessage: string
): MarketplaceActionError {
  const payload = normalizeMarketplaceErrorPayload(body);
  const message =
    typeof payload?.message === 'string' ? payload.message : fallbackMessage;
  const error = new Error(message) as MarketplaceActionError;
  if (typeof payload?.code === 'string') {
    error.code = payload.code;
  }
  if (typeof payload?.cause === 'string') {
    error.details = payload.cause;
  }
  if (Array.isArray(payload?.diagnostics)) {
    error.diagnostics = payload.diagnostics.flatMap((diagnostic: unknown) => {
      const parsed = CustomAppDiagnosticSchema.safeParse(diagnostic);
      return parsed.success ? [parsed.data] : [];
    });
  }
  return error;
}

export async function createMarketplaceResponseError(
  response: Response,
  fallbackMessage: string
): Promise<MarketplaceActionError> {
  const body = await response.json().catch(() => ({}));
  return createMarketplaceActionError(body, fallbackMessage);
}
